import { Modal } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { Trash } from 'phosphor-react'
import { useState } from 'react'
import { showAlertError } from 'src/components/alertError'
import { showAlertSuccess } from 'src/components/alertSuccess'
import { api } from 'src/services/api'
import { documentFormatted } from 'src/utils/documentFormatted'

type SplitAccount = {
  id: string
  name: string
  graphicAccountId: string
  pixKey: string
  accountId: string
  created_at: Date
  updated_at: Date
}

type Graphic = {
  id: string
  name: string
  document: string
  virtual_account_id: string
  created_at: Date
  updated_at: Date
}

export function Split() {
  const [loading, setLoading] = useState(true)
  const token = localStorage.getItem('@backoffice:token')

  const { data: splits, refetch } = useQuery({
    queryKey: ['list-splits'],
    queryFn: async () => {
      const response = await api.get<SplitAccount[]>(
        '/backoffice/split-accounts',
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )

      return response.data
    },
  })
  const { data: graphics } = useQuery({
    queryKey: ['list-graphics-splits'],
    queryFn: async () => {
      const response = await api.get<Graphic[]>(
        '/backoffice/graphic/split-accounts',
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )

      return response.data
    },
  })

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [selectedGraphicId, setSelectedGraphicId] = useState<
    string | undefined
  >(graphics ? graphics[0].id : undefined)

  const handleCreateSplit = async () => {
    if (!selectedGraphicId) return showAlertError('Selecione uma conta')

    setLoading(true)
    try {
      const response = await api.post(
        '/backoffice/split-accounts',
        {
          graphicAccountId: selectedGraphicId,
        },
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )

      refetch()
      showAlertSuccess('Split criada com sucesso')
      setModalIsOpen(false)
      setLoading(false)
    } catch (error: any) {
      setLoading(false)

      showAlertError(
        error?.response?.data?.message || 'Conta selecionada é inválida'
      )
    }
  }
  const handleDelete = async (splitId: string) => {
    setLoading(true)
    try {
      const response = await api.delete(
        `/backoffice/split-accounts/${splitId}`,
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )

      refetch()
      showAlertSuccess('Split apagada com sucesso')
      setModalIsOpen(false)
      setLoading(false)
    } catch (error: any) {
      setLoading(false)

      showAlertError(
        error?.response?.data?.message || 'Conta selecionada é inválida'
      )
    }
  }

  return (
    <div className="flex flex-col items-center w-full p-8">
      <Modal
        onClose={() => setModalIsOpen(false)}
        className="flex items-center justify-center"
        open={modalIsOpen}
      >
        <div className="flex gap-4 flex-col p-8 bg-white shadow-lg rounded-md">
          <span className="text-xl font-medium">Cadastrar conta split</span>
          <div className="flex flex-col gap-1">
            <span>Escolha uma conta:</span>
            <select
              id="graphicId"
              onChange={(e) => setSelectedGraphicId(e.target.value)}
              className="h-12 shadow-md border border-zinc-100 rounded-md px-4"
            >
              {graphics?.map((g) => (
                <option
                  key={g.id}
                  value={g.id}
                  onClick={() =>
                    !loading ? setSelectedGraphicId(g.id) : 'Carregando'
                  }
                >
                  {g.name} - {documentFormatted(g.document)}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={handleCreateSplit}
            className="bg-zinc-900 text-white font-medium px-2 py-1 rounded-md"
          >
            Cadastrar
          </button>
        </div>
      </Modal>
      <div className="flex flex-col max-w-[1200px] w-full">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-lg">Contas Split</span>
          <button
            onClick={() => setModalIsOpen(true)}
            className="bg-zinc-900 text-white font-medium px-2 py-1 rounded-md"
          >
            Cadastrar split
          </button>
        </div>
        <div className="flex flex-col w-full h-[480px] xl:h-[580px] 2xl:h-[700px] overflow-auto">
          {splits?.length === 0 ? (
            <span>Nenhuma Split cadastrada</span>
          ) : (
            <>
              <div className="flex items-center justify-between w-ful px-4 h-12 border border-zinc-50 rounded-md pr-12">
                <span className="flex flex-1">Nome</span>
                <span className="flex flex-1">AccountID</span>
                <span className="flex flex-1">Chave PIX</span>
              </div>
              <div className="flex flex-col w-full gap-2">
                {splits?.map((sp) => (
                  <div
                    className="flex items-center justify-between w-full bg-white px-4 h-12 border border-zinc-50 rounded-md"
                    key={sp.id}
                  >
                    <span className="flex flex-1">{sp.name}</span>
                    <span className="flex flex-1"> {sp.accountId}</span>
                    <span className="flex flex-1">{sp.pixKey}</span>
                    <button onClick={() => handleDelete(sp.id)} className="p-1">
                      <Trash color="#ff3333" size={18} />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
